import { createContext, useContext, useEffect, useState } from "react";
import { getProfile } from "../api";
import { commonUtil } from "../utils";
import { useLocation } from "react-router-dom";
import * as queryString from "query-string";

interface authContextType {
  isAuthenticated: boolean;
  user: any;
  login: (user: any) => void;
  logout: () => void;
}

const authContext = createContext<authContextType>({
  isAuthenticated: false,
  user: null,
  login: () => {},
  logout: () => {},
});

export const useAuth = () => {
  return useContext(authContext);
};

export const ProvideAuth = (props: any) => {
  const { search } = useLocation();
  const parseQuery = queryString.parse(search);

  if (parseQuery && parseQuery.accessToken && parseQuery.accessToken != "") {
    commonUtil.saveSession(
      parseQuery.accessToken,
      "",
      parseQuery.expiredDate
        ? parseInt(parseQuery.expiredDate as string)
        : 4 * 86400
    );
  }

  let accessToken = commonUtil.getAccessToken();
  const refreshToken = commonUtil.getRefreshToken();

  const [state, setState] = useState<{ isAuthenticated: boolean; user: any }>({
    isAuthenticated: Boolean(accessToken || refreshToken),
    user: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!accessToken) {
        return;
      }
      try {
        const resProfile = await getProfile();
        if (resProfile.status === "success") {
          login(resProfile.data);
        } else {
          commonUtil.deleteSession();
          logout();
        }
      } catch (error) {
        commonUtil.deleteSession();
        logout();
      }
    };

    fetchData();
  }, []);

  const login = (user: any) => {
    setState({ isAuthenticated: true, user });
  };

  const logout = () => {
    setState({ isAuthenticated: false, user: null });
  };

  return (
    <authContext.Provider
      value={{
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        login,
        logout,
      }}
    >
      {props.children}
    </authContext.Provider>
  );
};
